import { Component, inject, Input, ViewEncapsulation, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink, RouterLinkActive, RouterModule } from '@angular/router';

import { CommonService } from '../../shared/services/common.service';

import { SvgIconComponent } from '../../shared/components/common/svg-icon/svg-icon.component';
import { LoadingComponent } from '../../shared/skeleton-loader/widgets/loading/loading.component';
import { HttpClient } from '@angular/common/http';
import { NotificationService } from '../../services/notification.service';
import { UiNotificationModel } from '../../models/ui-notification-model';
import { NotificationCompComponent } from '../../component/notification-comp/notification-comp.component';
import { CommonModule } from '@angular/common';
import { generateRandomId } from '../../helpers/utils';
import { User } from '../../models/user';
import { AuthService } from '../../services/auth.service';
import { ResponseRequest } from '../../response-request';
import { NgbModal, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { album, closeAlbum, uploaded } from '../../shared/data/profile-pages/time-line';
import { AuthRegisterComponent } from '../auth-register/auth-register.component';
import { events } from '../../shared/interface/common';
import { FeatherIconComponent } from '../../shared/components/common/feather-icon/feather-icon.component';
import { BehaviorSubject } from 'rxjs';
import { SecureStorageService } from '../../services/secure-storage.service';


@Component({
  selector: 'app-auth-login',
  standalone: true,
  imports: [
    CommonModule, 
    ReactiveFormsModule,
    FeatherIconComponent,
    RouterLink,
    LoadingComponent,
    RouterLinkActive
  ],
  templateUrl: './auth-login.component.html',
  encapsulation: ViewEncapsulation.None  // Désactive l'encapsulation des styles
})


export class AuthLoginComponent implements OnInit {

  loginForm?: FormGroup;  
  isLoginSubmited: boolean = false;
  isLoading: boolean = false;
  errorMessage: string = '';

  private currentUserSubject = new BehaviorSubject<User | null>(null);
  currentUser$ = this.currentUserSubject.asObservable();

  @Input() events: events;

  showPassword = false;
  isMobile = false;

  constructor(
    private notificationService: NotificationService,
    private fb: FormBuilder, 
    private router: Router,
    private authService: AuthService,
    public commonService: CommonService,
    public modal: NgbModal,
    private secureStorage: SecureStorageService
  ) {}

  isModalOpen = false;

  openModal() {
    this.isModalOpen = true;
  }

  closeModal() {
    this.isModalOpen = false;
  }

  ngOnInit() {
    this.loginForm = this.fb.group({
      email: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(6)]]
    });

    this.isMobile = /Android|iPhone|iPad/i.test(navigator.userAgent);

    if (!this.isMobile) {
      this.initializeGoogleLogin();
    }

    // Vérifier si l'API Google Identity est chargée
    //this.checkGoogleIdentityAPI();
  }

  loginWithGoogleMobile() {

    window.location.href =
      "https://yokastarsnew-dev.apps.kubedev.hologram.cd/api/auth/google/redirect";

  }

  initializeGoogleLogin(): void {

  try {

    const google = (window as any).google;

    if (!google || !google.accounts || !google.accounts.id) {

      console.error("Google Identity indisponible");

      return;

    }

    google.accounts.id.initialize({

      client_id: "906933280693-7jqb2m7lhnfe639eu7oc7e7h3n8a0b5i.apps.googleusercontent.com",

      callback: this.handleGoogleLogin.bind(this),

      auto_select: false,

      cancel_on_tap_outside: true

    });

    setTimeout(() => {

      const button = document.getElementById("googleButton");

      if (!button) {

        console.error("googleButton introuvable");

        return;

      }

      button.innerHTML = "";

      google.accounts.id.renderButton(button, {

        theme: "outline",

        size: "large",

        width: 280

      });

      console.log("Google button rendu");

    }, 500);

  }
  catch (e) {

    console.error("Erreur initializeGoogleLogin:", e);

  }

}


  get loginFormControls() {
    return this.loginForm?.controls;
  }

  handleSubmitLogin(event?: Event) {
    localStorage.clear();
    event?.preventDefault();
    this.isLoginSubmited = true;
    if (this.loginForm?.invalid) return;

    this.isLoading = true;
    this.errorMessage = '';

    const loginCredentials = {
      email: this.loginForm?.get('email')?.value?.trim(),
      password: this.loginForm?.get('password')?.value
    };

    if (!loginCredentials.email || !loginCredentials.password) {
      this.isLoading = false;
      this.errorMessage = 'Veuillez remplir tous les champs';
      this.notificationService.create('Veuillez remplir tous les champs', 'danger', 2000);
      return;
    }

    this.authService.login(loginCredentials).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response.isSuccess) {
          this.notificationService.create('Connexion réussie', 'success', 2000);
          this.router.navigate(['/']);
        } else {
          console.log('response:', response.error.data.error);
          this.errorMessage = response.error.data.error || 'Échec de la connexion';
          this.notificationService.create(this.errorMessage, 'danger', 2000);
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = err.message || 'Une erreur est survenue';
        this.notificationService.create(this.errorMessage, 'danger', 2000);
      }     
      
    });
  }

  emit() {
    const notification: UiNotificationModel = {
      _id: generateRandomId(),
      title: 'Test',
      message: 'This is a test notification',
      status: 'danger',
      timeout: 2000
    }
    this.notificationService.emit(notification)
    console.log('notification:', notification.message);
  }

  choosePhoto() {
    this.modal.open(AuthRegisterComponent, { size: 'lg', windowClass: 'Choose-photo-modal' })
  }

  explore() {
    this.router.navigate(['/explore']);
  }

  // initializeGoogleLogin(): void {
  //   // Vérifier si la bibliothèque Google Identity est chargée
  //   const google = (window as any).google;
  //   if (!google || !google.accounts || !google.accounts.id) {
  //     console.warn('La bibliothèque Google Identity n\'est pas chargée');
  //     return;
  //   }

  //   // Initialiser l'API Google Identity
  //   google.accounts.id.initialize({
  //     client_id: '906933280693-7jqb2m7lhnfe639eu7oc7e7h3n8a0b5i.apps.googleusercontent.com',
  //     callback: this.handleGoogleLogin.bind(this),
  //     auto_select: false,
  //     cancel_on_tap_outside: true
  //   });

  //   // Utiliser setTimeout pour s'assurer que le DOM est chargé
  //   setTimeout(() => {
  //     const googleButton = document.getElementById('googleButton');
  //     if (googleButton) {
  //       google.accounts.id.renderButton(googleButton, { 
  //         theme: 'outline', 
  //         size: 'large',
  //         width: 240,
  //         text: 'signin_with',
  //         shape: 'rectangular'
  //       });
  //     } else {
  //       console.error('Élément googleButton non trouvé dans le DOM');
  //     }
  //   }, 500);
  // }

  handleGoogleLogin(response: any): void {
    this.isLoading = true;
    
    if (!response || !response.credential) {
      this.isLoading = false;
      this.errorMessage = 'Réponse Google invalide';
      this.notificationService.create('Échec de la connexion Google: réponse invalide', 'danger', 2000);
      return;
    }
    
    const credential = response.credential;
    console.log('Token JWT Google reçu:', credential.substring(0, 20) + '...');
    
    this.authService.googleLogin(credential).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && res.token) {
          this.notificationService.create('Connexion Google réussie', 'success', 2000);
          this.router.navigate(['/']).then(() => window.location.reload());
        } else {
          this.errorMessage = 'Réponse invalide du serveur';
          this.notificationService.create('Échec de la connexion Google: réponse invalide', 'danger', 2000);
        }
      },
      error: err => {
        this.isLoading = false;
        console.error('Erreur Google Login:', err);
        
        if (err.status === 401) {
          this.errorMessage = 'Authentification Google échouée';
        } else if (err.error?.message) {
          this.errorMessage = err.error.message;
        } else if (err.error?.error) {
          this.errorMessage = err.error.error;
        } else {
          this.errorMessage = 'Une erreur est survenue lors de la connexion Google';
        }
        
        this.notificationService.create(this.errorMessage, 'danger', 2000);
      }
    });
  }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  checkGoogleIdentityAPI(): void {

  const google = (window as any).google;

  if (google && google.accounts && google.accounts.id) {

    this.initializeGoogleLogin();

  }
  else {

    const script = document.createElement('script');

    script.src = "https://accounts.google.com/gsi/client";

    script.async = true;

    script.defer = true;

    script.onload = () => {

      console.log("Google Identity chargé");

      this.initializeGoogleLogin();

    };

    script.onerror = () => {

      console.error("Erreur chargement Google Identity");

    };

    document.head.appendChild(script);

  }

}


ngAfterViewInit(): void {

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (!isMobile) {

    setTimeout(() => {

      this.initializeGoogleLogin();

    }, 500);

  }

}
} 


